import {Http} from "../fetch/Http";
import HttpStatus from "../definitions/HttpStatus";

export interface SocialSignupInfo {
  email: string;
  socialId: string;
  loginType: string;
}

export const emptySocialSignupInfo: SocialSignupInfo = {
  email: "",
  socialId: "",
  loginType: "",
};


export interface NaverUserInfo {
  email: string,
  id: string
}

export interface LoginService {
  login(username: string, password: string, loginType: string, captcha?: string): Promise<boolean>;

  logout(): Promise<boolean>;

  logoutAdmin(): Promise<boolean>;

  getNaverUserInfo(accessToken: string): Promise<NaverUserInfo>;

}

export class NetworkLoginService implements LoginService {
  http: Http;

  constructor(http: Http) {
    this.http = http;
  }

  async login(username: string, password: string, loginType: string, captcha?: string): Promise<boolean> {
    // Spring Security 6.x 호환: application/x-www-form-urlencoded 사용
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);
    params.append("loginType", loginType);
    if (captcha) {
      params.append("captcha", captcha);
    }

    const result = await this.http.postUrlEncoded("/api/member/login", params);
    const loggedIn = result.status === HttpStatus.OK;

    return Promise.resolve(loggedIn);
  }

  async logout(): Promise<boolean> {
    let logoutUrl = "/api/member/logout";

    const result = await this.http.post(logoutUrl);

    let loggedOut = result.status === HttpStatus.OK;

    return Promise.resolve(loggedOut);
  }

  async logoutAdmin(): Promise<boolean> {
    let logoutUrl = "/api/boris/logout";

    const result = await this.http.post(logoutUrl);

    let loggedOut = result.status === HttpStatus.OK;

    return Promise.resolve(loggedOut);
  }

  async getNaverUserInfo(accessToken: string): Promise<NaverUserInfo> {
    const response = await this.http.get("/api/guest/getNaverUserInfo?accessToken=" + accessToken);
    return response.json();
  }
}